import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { Routes } from "../../routes/RouteConstants";
import { deepCopyFunction } from "../../services/utils";
import useAllCrditSkusStore from "../../zustandStores/allCreditSkus";
import classes from "./premiumPlanCards.module.css";
import cx from "classnames";
import LogService from "../../services/LogService";
import CREDIT_EVENTS from "../../utils/CreditEvents";

const PlanStepper = ({ maxQuantityAllowed }) => {
  const router = useRouter();
  const [jobCount, setJobCount] = useState(1);

  const { updateData, data } = useAllCrditSkusStore(state => ({
    updateData: state.updateData,
    data: state.data
  }));

  const pushQuantityInParams = value => {
    router.replace(
      {
        pathname: Routes.PLAN_SELECTION,
        query: {
          quantity: value
        }
      },
      undefined,
      { scroll: false }
    );
  };

  const updatePlanInfo = jobCount => {
    const tempData = deepCopyFunction(data);
    const newData = tempData.map(item => {
      if (item.maxQuantityAllowed > 1) {
        item.maximumRetailPrice = item.unitPrice * jobCount;
        item.credits = item.unitCredits * jobCount;
        item.label = `${jobCount} x Premium Job`;
      }
      return item;
    });
    updateData(newData);
  };

  const changeJobCount = value => {
    if (jobCount === 1 && value < 0) {
      LogService.log(CREDIT_EVENTS.CREDIT_SELECTION_STEPPER_NEG, {
        currentQuantity: jobCount,
        disabled: true
      });
      return;
    }
    if (jobCount === maxQuantityAllowed && value > 0) {
      LogService.log(CREDIT_EVENTS.CREDIT_SELECTION_STEPPER_POS, {
        currentQuantity: jobCount,
        disabled: true
      });
      return;
    }
    const updatedJobCount = jobCount + value;

    if (value < 0) {
      LogService.log(CREDIT_EVENTS.CREDIT_SELECTION_STEPPER_NEG, {
        currentQuantity: jobCount,
        updatedQuantity: updatedJobCount
      });
    } else {
      LogService.log(CREDIT_EVENTS.CREDIT_SELECTION_STEPPER_POS, {
        currentQuantity: jobCount,
        updatedQuantity: updatedJobCount
      });
    }
    setJobCount(updatedJobCount);
    pushQuantityInParams(updatedJobCount);
    updatePlanInfo(updatedJobCount);
  };

  useEffect(() => {
    const { quantity = 1 } = router.query;
    const quantityInt = parseInt(quantity);
    if (quantityInt > 0 && quantityInt <= maxQuantityAllowed) {
      setJobCount(quantityInt);
      updatePlanInfo(quantityInt);
    } else {
      pushQuantityInParams(1);
    }
  }, []);

  return (
    <div
      className={cx(
        "flex md:justify-center items-center md:mt-8",
        classes.planCnt
      )}
    >
      <button
        className={cx(classes.stepperBtn, {
          [classes.disabled]: jobCount === 1
        })}
        onClick={() => changeJobCount(-1)}
      >
        <img src="/hire/subtract-icon.svg" alt="minus" />
      </button>
      <div className={classes.stepperCountCnt}>{jobCount}</div>
      <button
        className={cx(classes.stepperBtn, {
          [classes.disabled]: jobCount === maxQuantityAllowed
        })}
        onClick={() => changeJobCount(1)}
      >
        <img src="/hire/add-icon.svg" alt="add" />
      </button>
    </div>
  );
};
export default PlanStepper;
